import { render, staticRenderFns } from "./BaseRoundButton.vue?vue&type=template&id=4f56faf7&scoped=true&"
import script from "./BaseRoundButton.vue?vue&type=script&lang=js&"
export * from "./BaseRoundButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseRoundButton.vue?vue&type=style&index=0&id=4f56faf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f56faf7",
  null
  
)

export default component.exports